import { Role, RolePermission, RolePermissionMatrix } from '../../helpers/permissions';

export interface PermissionsExtendedState {
    presetId: string;
    matrix: RolePermissionMatrix;
    matrixOverride: RolePermissionMatrix | null;
    status: PermissionsExtendedStatus | null;
    nonConfigurablePermissions: RolePermission[];
    haveChangedFromDefault: boolean;
}

export interface SetMatrixRolePermissionPayload {
    role: Role;
    rolePermission: RolePermission;
    value: boolean;
}

export enum PermissionsExtendedStatus {
    FULLFILLED = 'fullfilled',
    MATRIX_LOADING = 'matrix-loading',
    APPLY_MATRIX_LOADING = 'apply-matrix-loading',
    RESET_TO_DEFAULT_LOADING = 'reset-to-default-loading',
    INIT_ERROR = 'init-error',
}
